import { render, staticRenderFns } from "./DocentHistoryList.vue?vue&type=template&id=3d1d6919&scoped=true"
import script from "./DocentHistoryList.vue?vue&type=script&lang=js"
export * from "./DocentHistoryList.vue?vue&type=script&lang=js"
import style0 from "./DocentHistoryList.vue?vue&type=style&index=0&id=3d1d6919&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1d6919",
  null
  
)

export default component.exports